<script>

	export let headline = '';
	export let text = ''
</script>

<div class="content">
	{#if headline || text}
		{#if headline}
			<div class="headline">{@html headline}</div>
		{/if}
		{#if text}
			<div class="text">{@html text}</div>
		{/if}
	{/if}
</div>

<style lang="scss">
	.content {
		margin: 0 auto;
		width: 100%;
		background: $slide-background;
		position: relative;
		box-sizing: border-box;
		box-shadow: 0px 16px 61px #000000;
		border-radius: 2px;
		letter-spacing: 0.01em;
		max-width: 450px;

		.headline {
			font-weight: $bold;
			margin-bottom: 5px;
		}
	}

	@media (min-width: #{$breakpoint-mobile + 1px}) {
		.content {
			padding: 25px 30px;
			font-size: 20px;
			line-height: 28px;
		}
	}

	@media (max-width: $breakpoint-mobile) {
		.content {
			padding: 15px 20px;
			font-size: 18px;
			line-height: 27px;
			margin: 0 10px;
			box-sizing: border-box;
		}
	}
</style>
